import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { trackWhatsAppClick } from '../utils/analytics';

const WHATSAPP_URL = "https://wa.me/918527043856?text=Hi%20CinCin,%20I'm%20planning%20an%20event%20and%20would%20like%20to%20connect.";

export default function WhatsAppFloat() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 2500);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <motion.a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackWhatsAppClick('floating_button')}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
      data-testid="whatsapp-floating-button"
      className="whatsapp-float"
      aria-label="Contact via WhatsApp"
    >
      <MessageCircle size={20} strokeWidth={1.5} color="#0A0A0A" />
    </motion.a>
  );
}
